import { createFileRoute } from '@tanstack/react-router';

import { ContainerLibraryView } from '../../../features/containers/container-library-view';

export const Route = createFileRoute('/admin/containers/')({
  component: ContainerLibraryView,
});
